<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="nom">Nom du secteur</label>
          <input type="text" class="form-control" id="nom" v-model="secteur.nom" maxlength="50" required>
        </div>

        <label for="arrondissement">Arrondissement de rattachement</label>
        <div v-for="(arr, value) in currentVille.arrondissements" v-bind:key="value">
            <div class="radio">
            <label>
              <input type="radio" name="arrondissement" v-bind:value="arr.id" v-model="secteur.arrondissement_id" required>
              {{arr.nom}}
            </label>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'currentVille',
    ]),
  },
  props: [
    'updateSecteur',
  ],
  data: function () {
    return {
      secteur: this.updateSecteur ? _.cloneDeep(this.updateSecteur) : {arrondissement_id: this.$store.state.currentVille.arrondissements[0].id,},
    }
  },
  methods: {
    confirm: function () {
      if (this.updateSecteur) {
        this.$store.dispatch('updateSecteur',this.secteur)
      } else {
        this.$store.dispatch('createSecteur',this.secteur)
      }
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// SecteursForm.vue?be28add8